app.ActiveVacancyLists = (
    function () {
        var activeVacancyLists = {
            //Index Page
            Index: function () {
                app.SavedVacancies.Init();
                $(document).ready(function () {
                    app.page.components["ActiveVacancyListGrid"][0].refreshGrid();

                    $("#txtUrlText").val(window.location.href);

                    // for URL copying
                    $("#btnCopyUrl").on("click",
                        function () {
                            $("#txtUrlText").focus().select();
                            document.execCommand("copy");
                            toastr.success("URL has been copied to clipboard.");
                        });
                });
            }
        };
        return activeVacancyLists;
    }()
);